export const NAME = 'cycles';
export const LEVEL_ONE = 'CyclesComponentReducer';
